import React from "react";
import { Col, Container, Row, Tabs, Tab, Accordion } from "react-bootstrap";
import { Link } from "gatsby";

function Appbuild(props) {
  return (
    <div className="services_buildapp p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Consulting">
              <h2>Your Choice For Startup Consulting Firms</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              We thrive on disrupting the sphere when building a lean startup.
              The process starts with developing a lean startup business plan
              which later translates into strategic and tactical guidelines to
              be followed. Experienced startup consulting firms ensure that the
              process is followed to get the desired outcome.
            </p>
          </Col>
        </Row>
        <Row className="services_bg ">
          <Col
            xs={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="services_tabs deskstop_version"
          >
            <Tabs defaultActiveKey="0" transition={false}>
              <Tab eventKey="0" title="Gaming">
                <div className="content_tabs">
                  <h2>Ether Legend</h2>
                  <p>
                    Ether Legends is a Blockchain-based NFT card trading game
                    powered by Enjin, Polygon, and Ethereum networks and built
                    by TekRevol. The “play-to-earn” functionality of the game
                    allows players to collect NFTs as rewards and save them as
                    their digital assets.
                  </p>
                  <Link to="/case-studies/ether-legends">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="1" title="Productivity">
                <div className="content_tabs">
                  <h2>AMJ Wellness</h2>
                  <p>
                    The digital solution ensures a healthy relationship between
                    employee well-being and productivity. AMJ Workplace Wellness
                    is an app built by TekRevol that ensures employees' mental
                    and physical well-being and maps them to their productivity.
                    Later, all this ties to overall organizational performance.
                  </p>
                  <Link to="/case-studies/amj-wellness">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="2" title="Marketplace">
                <div className="content_tabs">
                  <h2>High Def Events</h2>
                  <p>
                    The High Def Events app is a one-of-a-kind digital
                    auctioneering platform that allows users to interact with
                    the app, create videos and visuals of their products, put
                    them on auction through relevant screens, and attract
                    visitors to buy these products through the application.
                  </p>
                  <Link to="/case-studies/hde">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="3" title="Socializing">
                <div className="content_tabs">
                  <h2>TeeMates</h2>
                  <p>
                    A unique socializing platform, TeeMates, is built
                    specifically for golfers worldwide. The app has all the
                    modern features and functions for the golfer community.
                    After signing up, the users can collaborate, share their
                    stories, and connect with golfers worldwide.
                  </p>
                  <Link to="/case-studies/teemates">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="4" title="Entertainment">
                <div className="content_tabs">
                  <h2>FSK</h2>
                  <p>
                    FSK redefines mobile gaming by seamlessly blending match-3
                    puzzles, time managementchallenges, and role-playing
                    elements. Players embark on a culinary adventure,building a
                    restaurant empire, and applying real-time market strategies
                    to crafttheir success.
                  </p>
                  <Link to="/case-studies/fsk">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="5" title="Lifestyle">
                <div className="content_tabs">
                  <h2>Stop Vaping</h2>
                  <p>
                    A vast market worldwide uses various lifestyle digital
                    products, from web apps to smartwatch widgets to desktop
                    programs. These digital solutions provide helpful content,
                    information, and products to the users and present immense
                    potential for making money through multiple monetization
                    models. TekRevol can build the right lifestyle solution for
                    you.
                  </p>
                  <Link to="/case-studies/stop-vaping">See case study</Link>
                </div>
              </Tab>
            </Tabs>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="services_tabs mobile_version"
          >
            <div className="tekrevol_mobile_accordion">
              <Accordion defaultActiveKey="01">
                <Accordion.Item eventKey="01">
                  <Accordion.Header>Ether Legend</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Ether Legends is a Blockchain-based NFT card trading game
                      powered by Enjin, Polygon, and Ethereum networks and built
                      by TekRevol. The “play-to-earn” functionality of the game
                      allows players to collect NFTs as rewards and save them as
                      their digital assets.
                    </p>
                    <Link to="/case-studies/ether-legends">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="02">
                  <Accordion.Header>AMJ Wellness</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      The digital solution ensures a healthy relationship
                      between employee well-being and productivity. AMJ
                      Workplace Wellness is an app built by TekRevol that
                      ensures employees' mental and physical well-being and maps
                      them to their productivity. Later, all this ties to
                      overall organizational performance.
                    </p>
                    <Link to="/case-studies/amj-wellness">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="03">
                  <Accordion.Header>High Def Events</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      The High Def Events app is a one-of-a-kind digital
                      auctioneering platform that allows users to interact with
                      the app, create videos and visuals of their products, put
                      them on auction through relevant screens, and attract
                      visitors to buy these products through the application.
                    </p>
                    <Link to="/case-studies/hde">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="04">
                  <Accordion.Header>TeeMates</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      A unique socializing platform, TeeMates, is built
                      specifically for golfers worldwide. The app has all the
                      modern features and functions for the golfer community.
                      After signing up, the users can collaborate, share their
                      stories, and connect with golfers worldwide.
                    </p>
                    <Link to="/case-studies/teemates">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="05">
                  <Accordion.Header>FSK</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      FSK redefines mobile gaming by seamlessly blending match-3
                      puzzles, time managementchallenges, and role-playing
                      elements. Players embark on a culinary adventure,building
                      a restaurant empire, and applying real-time market
                      strategies to crafttheir success.
                    </p>
                    <Link to="/case-studies/fsk">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="06">
                  <Accordion.Header>Stop Vaping</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      A vast market worldwide uses various lifestyle digital
                      products, from web apps to smartwatch widgets to desktop
                      programs. These digital solutions provide helpful content,
                      information, and products to the users and present immense
                      potential for making money through multiple monetization
                      models. TekRevol can build the right lifestyle solution
                      for you.
                    </p>
                    <Link to="/case-studies/stop-vaping">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={4}
            xl={4}
            xxl={4}
            className="services_grade_tabs"
          >
            <Tabs defaultActiveKey="0">
              <Tab eventKey="0" title="Silver">
                <div className="tab_hour">
                  <h4>
                    1172 Hours<span>Average Development Time</span>
                  </h4>
                  <h4>
                    07 Months<span>Average Project Length</span>
                  </h4>
                </div>
              </Tab>
              <Tab eventKey="1" title="Gold">
                <div className="tab_hour">
                  <h4>
                    1619 Hours<span>Average Development Time</span>
                  </h4>
                  <h4>
                    09 Months<span>Average Project Length</span>
                  </h4>
                </div>
              </Tab>
              <Tab eventKey="2" title="Platinum">
                <div className="tab_hour">
                  <h4>
                    3116 Hours<span>Average Development Time</span>
                  </h4>
                  <h4>
                    18 Months<span>Average Project Length</span>
                  </h4>
                </div>
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Appbuild;
